import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Consultations from './pages/Consultations';
import ConsultationPackage from './pages/ConsultationPackage';
import ConsultationDetail from './pages/ConsultationDetail';
import ShoppingList from './pages/ShoppingList';
import Comments from './pages/Comments';
import Login from './pages/Login';
import Register from './pages/Register';
import Account from './pages/Account';
import Designer from './pages/Designer';
import PaymentSuccess from './pages/PaymentSuccess';
import MyConsultations from './pages/MyConsultations';
import './App.css';

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="py-32 text-center text-stilo-ink2">Cargando…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ExternalRedirect({ to }) {
  React.useEffect(() => { window.location.replace(to); }, [to]);
  return <div className="py-32 text-center text-stilo-ink2">Llevándote a Stilo Decor…</div>;
}

function Shell() {
  return (
    <div className="min-h-screen flex flex-col bg-stilo-bg">
      <Header />
      <ScrollToTop />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/tienda" element={<ExternalRedirect to="https://www.stilodecor.com" />} />
          <Route path="/producto/:handle" element={<ExternalRedirect to="https://www.stilodecor.com" />} />
          <Route path="/asesorias" element={<Consultations />} />
          <Route path="/asesorias/:slug" element={<ConsultationPackage />} />
          <Route path="/comentarios" element={<Comments />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/cuenta" element={<Protected><Account /></Protected>} />
          <Route path="/asesoria/:id" element={<Protected><ConsultationDetail /></Protected>} />
          <Route path="/shopping-list" element={<Protected><ShoppingList /></Protected>} />
          <Route path="/mis-asesorias" element={<Protected><MyConsultations mode="asesorias" /></Protected>} />
          <Route path="/conversaciones" element={<Protected><MyConsultations mode="conversaciones" /></Protected>} />
          <Route path="/designer" element={<Protected><Designer /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors />
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}
